import { useState, useEffect } from 'react';

export default function useMobileDetect(breakpoint = 990) {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint + 1);

  useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint}px)`);
    const onChange = (e: MediaQueryListEvent) => setIsMobile(e.matches);

    setIsMobile(mql.matches);
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return isMobile;
}
